/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your height and weight to see your BMI.`)
};

const es_bmi_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce tu altura y peso para ver tu IMC.`)
};

const de_bmi_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie Ihre Größe und Gewicht ein, um Ihren BMI zu sehen.`)
};

const nl_bmi_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer uw lengte en gewicht in om uw BMI te zien.`)
};

const fr_bmi_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez votre taille et votre poids pour voir votre IMC.`)
};

const it_bmi_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci la tua altezza e il tuo peso per vedere il tuo BMI.`)
};

const pt_br2_bmi_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite sua altura e peso para ver seu BMI.`)
};

const pt_bmi_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite a sua altura e peso para ver o seu IMC.`)
};

const ja_bmi_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身長と体重を入力してBMIを確認してください。`)
};

const zh_bmi_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入您的身高和体重以查看您的 BMI。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_enter = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_enter(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_enter", locale)
	if (locale === "en") return en_bmi_enter(inputs)
	if (locale === "es") return es_bmi_enter(inputs)
	if (locale === "de") return de_bmi_enter(inputs)
	if (locale === "nl") return nl_bmi_enter(inputs)
	if (locale === "fr") return fr_bmi_enter(inputs)
	if (locale === "it") return it_bmi_enter(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_enter(inputs)
	if (locale === "pt") return pt_bmi_enter(inputs)
	if (locale === "ja") return ja_bmi_enter(inputs)
	return zh_bmi_enter(inputs)
};